export const addDecimals = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

export const updateCart = (state) => {
  //*   CALCULATE ITEMS PRICE
  state.itemsPrice = addDecimals(
    state.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0)
  );

  //*   CALCULATE SHIPPING PRICE
  state.shippingPrice = addDecimals(state.itemsPrice > 100 ? 0 : 10);

  //*   CALCULATE TAX PRICE
  state.taxPrice = addDecimals(Number((0.15 * state.itemsPrice).toFixed(2)));

  //*   CALCULATE TOTAL PRICE
  state.totalPrice = (
    Number(state.itemsPrice) +
    Number(state.shippingPrice) +
    Number(state.taxPrice)
  ).toFixed(2);

  localStorage.setItem('cartitems', JSON.stringify(state.cartItems));

  return state;
};
